import { render } from "./LoadingScreen.vue?vue&type=template&id=448bf8e9&scoped=true"
const script = {}

import "./LoadingScreen.vue?vue&type=style&index=0&id=448bf8e9&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448bf8e9"]])

export default __exports__